/* ======================================================================== */
/* 25. figureProperty */
/* ======================================================================== */
var FigureProperty = function ($scope) {

	var $target = $scope.find('.figure-property[data-os-animation]');

	if (!$target.length) {
		return;
	}

	var $headline = $target.find('.figure-property__headline');

	prepare();
	animate();

	function prepare() {

		TweenMax.set($headline, {
			scaleX: 0,
			transformOrigin: 'left center'
		});

	}

	function animate() {

		var tl = new TimelineMax();

		tl.add(animateLines($target, 1.2, 0.01));

		createOSScene($target, tl);

	}

}
